// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CSS Variables for theming */
:root {
  /* Light theme colors - improved contrast */
  --bg-primary: #ffffff;
  --bg-secondary: #f8f9fa;
  --text-primary: #1a1a1a;
  --text-secondary: #4a4a4a;
  --accent-color: #1976d2;
  --accent-bg: rgba(25, 118, 210, 0.1);
  --accent-hover: rgba(25, 118, 210, 0.2);
  --border-color: #d0d0d0;
  --shadow-color: rgba(0, 0, 0, 0.15);

  /* Disabled MUI colors - light mode */
  --disabled-input-text: rgba(0, 0, 0, 0.55);
  --disabled-input-border: rgba(0, 0, 0, 0.23);
  --disabled-input-icon: rgba(0, 0, 0, 0.45);

  /* Disabled MUI button colors - light mode */
  --disabled-button-bg: rgba(0, 0, 0, 0.08);
  --disabled-button-text: rgba(0, 0, 0, 0.45);
  --disabled-button-border: rgba(0, 0, 0, 0.18);
}

[data-theme='dark'] {
  /* Dark theme colors */
  --bg-primary: #282c34;
  --bg-secondary: #1e1e1e;
  --text-primary: #ffffff;
  --text-secondary: #cccccc;
  --accent-color: #61dafb;
  --accent-bg: rgba(97, 218, 251, 0.1);
  --accent-hover: rgba(97, 218, 251, 0.2);
  --border-color: #ffffff;
  --shadow-color: rgba(0, 0, 0, 0.3);

  /* Disabled MUI colors - dark mode */
  --disabled-input-text: rgba(255, 255, 255, 0.78);
  --disabled-input-border: rgba(255, 255, 255, 0.28);
  --disabled-input-icon: rgba(255, 255, 255, 0.55);

  /* Disabled MUI button colors - dark mode */
  --disabled-button-bg: rgba(255, 255, 255, 0.12);
  --disabled-button-text: rgba(255, 255, 255, 0.65);
  --disabled-button-border: rgba(255, 255, 255, 0.25);
}

/* Global styles to handle iOS safe areas */
html,
body {
  background-color: var(--bg-primary);
  margin: 0;
  padding: 0;
  color: var(--text-primary);
  transition:
    background-color 0.3s ease,
    color 0.3s ease;
}

/* MUI disabled TextField - outlined variant */
.MuiOutlinedInput-root.Mui-disabled {
  background-color: var(--disabled-input-bg);
}

.MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline {
  border-color: var(--disabled-input-border);
}

.MuiOutlinedInput-input.Mui-disabled {
  color: var(--disabled-input-text);
  -webkit-text-fill-color: var(--disabled-input-text);
  opacity: 1;
}

/* MUI disabled Input - standard variant */
.MuiInput-root.Mui-disabled {
  background-color: var(--disabled-input-bg);
  border-radius: 4px;
  padding-left: 8px;
  padding-right: 8px;
}

.MuiInput-root.Mui-disabled::before,
.MuiInput-root.Mui-disabled:hover:not(.Mui-error)::before {
  border-bottom-color: var(--disabled-input-border);
}

.MuiInputBase-input.Mui-disabled {
  color: var(--disabled-input-text);
  -webkit-text-fill-color: var(--disabled-input-text);
  opacity: 1;
}

/* MUI disabled FormControlLabel */
.MuiFormControlLabel-root.Mui-disabled {
  color: var(--disabled-input-text);
}

.MuiFormControlLabel-root.Mui-disabled .MuiFormControlLabel-label {
  color: var(--disabled-input-text);
  opacity: 1;
}

/* Disabled checkbox, switch, radio icons */
.MuiFormControlLabel-root.Mui-disabled .MuiSvgIcon-root,
.MuiCheckbox-root.Mui-disabled,
.MuiRadio-root.Mui-disabled,
.MuiSwitch-root.Mui-disabled {
  color: var(--disabled-input-icon);
}

/* Disabled icons inside MUI inputs */
.MuiIconButton-root.Mui-disabled {
  color: var(--disabled-input-icon);
}

/* MUI disabled Buttons */
.MuiButton-root.Mui-disabled {
  color: var(--disabled-button-text);
  background-color: var(--disabled-button-bg);
  border-color: var(--disabled-button-border);
  opacity: 1;
}

/* Disabled text buttons should not get a filled background */
.MuiButton-text.Mui-disabled {
  background-color: transparent;
  color: var(--disabled-button-text);
}

/* Disabled outlined buttons */
.MuiButton-outlined.Mui-disabled {
  border-color: var(--disabled-button-border);
  color: var(--disabled-button-text);
}

/* Disabled contained buttons */
.MuiButton-contained.Mui-disabled {
  background-color: var(--disabled-button-bg);
  color: var(--disabled-button-text);
}

/* Disabled button icons */
.MuiButton-root.Mui-disabled .MuiSvgIcon-root,
.MuiButton-root.Mui-disabled .MuiButton-startIcon,
.MuiButton-root.Mui-disabled .MuiButton-endIcon {
  color: var(--disabled-button-text);
}

/* iOS safe area handling */
@supports (padding: max(0px)) {
  body {
    padding-left: max(0px, env(safe-area-inset-left));
    padding-right: max(0px, env(safe-area-inset-right));
    padding-top: max(0px, env(safe-area-inset-top));
    padding-bottom: max(0px, env(safe-area-inset-bottom));
  }
}

.App {
  text-align: center;
  background-color: var(--bg-primary);
  min-height: 100vh;
  min-height: 100dvh; /* Use dynamic viewport height for mobile */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: var(--text-primary);
  /* Ensure the app covers the full viewport including safe areas */
  position: relative;
  width: 100%;
  transition:
    background-color 0.3s ease,
    color 0.3s ease;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-link {
  color: var(--accent-color);
  transition: color 0.3s ease;
}

.App-link:hover {
  color: var(--text-primary);
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,8BAA8B;AAC9B;EACE,2CAA2C;EAC3C,qBAAqB;EACrB,uBAAuB;EACvB,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;EACvB,oCAAoC;EACpC,uCAAuC;EACvC,uBAAuB;EACvB,mCAAmC;;EAEnC,qCAAqC;EACrC,0CAA0C;EAC1C,4CAA4C;EAC5C,0CAA0C;;EAE1C,4CAA4C;EAC5C,yCAAyC;EACzC,2CAA2C;EAC3C,6CAA6C;AAC/C;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;EACvB,oCAAoC;EACpC,uCAAuC;EACvC,uBAAuB;EACvB,kCAAkC;;EAElC,oCAAoC;EACpC,gDAAgD;EAChD,kDAAkD;EAClD,gDAAgD;;EAEhD,2CAA2C;EAC3C,+CAA+C;EAC/C,iDAAiD;EACjD,mDAAmD;AACrD;;AAEA,2CAA2C;AAC3C;;EAEE,mCAAmC;EACnC,SAAS;EACT,UAAU;EACV,0BAA0B;EAC1B;;mBAEiB;AACnB;;AAEA,8CAA8C;AAC9C;EACE,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,iCAAiC;EACjC,mDAAmD;EACnD,UAAU;AACZ;;AAEA,0CAA0C;AAC1C;EACE,0CAA0C;EAC1C,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;EAEE,iDAAiD;AACnD;;AAEA;EACE,iCAAiC;EACjC,mDAAmD;EACnD,UAAU;AACZ;;AAEA,kCAAkC;AAClC;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;EACjC,UAAU;AACZ;;AAEA,2CAA2C;AAC3C;;;;EAIE,iCAAiC;AACnC;;AAEA,qCAAqC;AACrC;EACE,iCAAiC;AACnC;;AAEA,yBAAyB;AACzB;EACE,kCAAkC;EAClC,2CAA2C;EAC3C,2CAA2C;EAC3C,UAAU;AACZ;;AAEA,6DAA6D;AAC7D;EACE,6BAA6B;EAC7B,kCAAkC;AACpC;;AAEA,8BAA8B;AAC9B;EACE,2CAA2C;EAC3C,kCAAkC;AACpC;;AAEA,+BAA+B;AAC/B;EACE,2CAA2C;EAC3C,kCAAkC;AACpC;;AAEA,0BAA0B;AAC1B;;;EAGE,kCAAkC;AACpC;;AAEA,2BAA2B;AAC3B;EACE;IACE,iDAAiD;IACjD,mDAAmD;IACnD,+CAA+C;IAC/C,qDAAqD;EACvD;AACF;;AAEA;EACE,kBAAkB;EAClB,mCAAmC;EACnC,iBAAiB;EACjB,kBAAkB,EAAE,2CAA2C;EAC/D,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,0BAA0B;EAC1B,iEAAiE;EACjE,kBAAkB;EAClB,WAAW;EACX;;mBAEiB;AACnB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":["/* CSS Variables for theming */\n:root {\n  /* Light theme colors - improved contrast */\n  --bg-primary: #ffffff;\n  --bg-secondary: #f8f9fa;\n  --text-primary: #1a1a1a;\n  --text-secondary: #4a4a4a;\n  --accent-color: #1976d2;\n  --accent-bg: rgba(25, 118, 210, 0.1);\n  --accent-hover: rgba(25, 118, 210, 0.2);\n  --border-color: #d0d0d0;\n  --shadow-color: rgba(0, 0, 0, 0.15);\n\n  /* Disabled MUI colors - light mode */\n  --disabled-input-text: rgba(0, 0, 0, 0.55);\n  --disabled-input-border: rgba(0, 0, 0, 0.23);\n  --disabled-input-icon: rgba(0, 0, 0, 0.45);\n\n  /* Disabled MUI button colors - light mode */\n  --disabled-button-bg: rgba(0, 0, 0, 0.08);\n  --disabled-button-text: rgba(0, 0, 0, 0.45);\n  --disabled-button-border: rgba(0, 0, 0, 0.18);\n}\n\n[data-theme='dark'] {\n  /* Dark theme colors */\n  --bg-primary: #282c34;\n  --bg-secondary: #1e1e1e;\n  --text-primary: #ffffff;\n  --text-secondary: #cccccc;\n  --accent-color: #61dafb;\n  --accent-bg: rgba(97, 218, 251, 0.1);\n  --accent-hover: rgba(97, 218, 251, 0.2);\n  --border-color: #ffffff;\n  --shadow-color: rgba(0, 0, 0, 0.3);\n\n  /* Disabled MUI colors - dark mode */\n  --disabled-input-text: rgba(255, 255, 255, 0.78);\n  --disabled-input-border: rgba(255, 255, 255, 0.28);\n  --disabled-input-icon: rgba(255, 255, 255, 0.55);\n\n  /* Disabled MUI button colors - dark mode */\n  --disabled-button-bg: rgba(255, 255, 255, 0.12);\n  --disabled-button-text: rgba(255, 255, 255, 0.65);\n  --disabled-button-border: rgba(255, 255, 255, 0.25);\n}\n\n/* Global styles to handle iOS safe areas */\nhtml,\nbody {\n  background-color: var(--bg-primary);\n  margin: 0;\n  padding: 0;\n  color: var(--text-primary);\n  transition:\n    background-color 0.3s ease,\n    color 0.3s ease;\n}\n\n/* MUI disabled TextField - outlined variant */\n.MuiOutlinedInput-root.Mui-disabled {\n  background-color: var(--disabled-input-bg);\n}\n\n.MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline {\n  border-color: var(--disabled-input-border);\n}\n\n.MuiOutlinedInput-input.Mui-disabled {\n  color: var(--disabled-input-text);\n  -webkit-text-fill-color: var(--disabled-input-text);\n  opacity: 1;\n}\n\n/* MUI disabled Input - standard variant */\n.MuiInput-root.Mui-disabled {\n  background-color: var(--disabled-input-bg);\n  border-radius: 4px;\n  padding-left: 8px;\n  padding-right: 8px;\n}\n\n.MuiInput-root.Mui-disabled::before,\n.MuiInput-root.Mui-disabled:hover:not(.Mui-error)::before {\n  border-bottom-color: var(--disabled-input-border);\n}\n\n.MuiInputBase-input.Mui-disabled {\n  color: var(--disabled-input-text);\n  -webkit-text-fill-color: var(--disabled-input-text);\n  opacity: 1;\n}\n\n/* MUI disabled FormControlLabel */\n.MuiFormControlLabel-root.Mui-disabled {\n  color: var(--disabled-input-text);\n}\n\n.MuiFormControlLabel-root.Mui-disabled .MuiFormControlLabel-label {\n  color: var(--disabled-input-text);\n  opacity: 1;\n}\n\n/* Disabled checkbox, switch, radio icons */\n.MuiFormControlLabel-root.Mui-disabled .MuiSvgIcon-root,\n.MuiCheckbox-root.Mui-disabled,\n.MuiRadio-root.Mui-disabled,\n.MuiSwitch-root.Mui-disabled {\n  color: var(--disabled-input-icon);\n}\n\n/* Disabled icons inside MUI inputs */\n.MuiIconButton-root.Mui-disabled {\n  color: var(--disabled-input-icon);\n}\n\n/* MUI disabled Buttons */\n.MuiButton-root.Mui-disabled {\n  color: var(--disabled-button-text);\n  background-color: var(--disabled-button-bg);\n  border-color: var(--disabled-button-border);\n  opacity: 1;\n}\n\n/* Disabled text buttons should not get a filled background */\n.MuiButton-text.Mui-disabled {\n  background-color: transparent;\n  color: var(--disabled-button-text);\n}\n\n/* Disabled outlined buttons */\n.MuiButton-outlined.Mui-disabled {\n  border-color: var(--disabled-button-border);\n  color: var(--disabled-button-text);\n}\n\n/* Disabled contained buttons */\n.MuiButton-contained.Mui-disabled {\n  background-color: var(--disabled-button-bg);\n  color: var(--disabled-button-text);\n}\n\n/* Disabled button icons */\n.MuiButton-root.Mui-disabled .MuiSvgIcon-root,\n.MuiButton-root.Mui-disabled .MuiButton-startIcon,\n.MuiButton-root.Mui-disabled .MuiButton-endIcon {\n  color: var(--disabled-button-text);\n}\n\n/* iOS safe area handling */\n@supports (padding: max(0px)) {\n  body {\n    padding-left: max(0px, env(safe-area-inset-left));\n    padding-right: max(0px, env(safe-area-inset-right));\n    padding-top: max(0px, env(safe-area-inset-top));\n    padding-bottom: max(0px, env(safe-area-inset-bottom));\n  }\n}\n\n.App {\n  text-align: center;\n  background-color: var(--bg-primary);\n  min-height: 100vh;\n  min-height: 100dvh; /* Use dynamic viewport height for mobile */\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: var(--text-primary);\n  /* Ensure the app covers the full viewport including safe areas */\n  position: relative;\n  width: 100%;\n  transition:\n    background-color 0.3s ease,\n    color 0.3s ease;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-link {\n  color: var(--accent-color);\n  transition: color 0.3s ease;\n}\n\n.App-link:hover {\n  color: var(--text-primary);\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
